import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import FooterSocialIcons from './FooterSocialIcons';
import { ArrowRightIcon } from './Icons';
import { appendTrackingParams } from '../utils/tracking';

const contactStyle = {
  color: "#6c757d",
  fontSize: "0.900rem",
  marginBottom: "0px"
}

const RightSideMenu = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const placement = "end";

  return (
    <>

      <img src="/assets/images/hamburg_menu.webp" onClick={handleShow} alt="menu icon" />

      <Offcanvas show={show} onHide={handleClose} placement={placement}>
        <Offcanvas.Header closeButton>
          <div className="header-right-group">
            <a className="nav-link btn header-menu-btn gf-btn me-3" href={appendTrackingParams("https://myaccount.getfriday.com/web/login")} target="_blank" rel="noopener noreferrer" onClick={handleClose}>
              <span className="d-flex align-content-center">Login <ArrowRightIcon className="ms-1" /></span>
            </a>
            <a className="nav-link btn header-menu-btn gf-btn me-3" href={appendTrackingParams("https://myaccount.getfriday.com/web/signup")} target="_blank" rel="noopener noreferrer" onClick={handleClose}>
              <span className="d-flex align-content-center">Sign Up <ArrowRightIcon className="ms-1" /></span>
            </a>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navbar-nav">

            {/* Dropdown Menu */}
            <li className="nav-item dropdown show-in-mobile">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
                For Personal
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li className="nav-item"><a className="dropdown-item" href="/personal/virtual-personal-assistant" onClick={handleClose}>For Personal</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/family-and-personal" onClick={handleClose}>Family & Personal</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/travel-management" onClick={handleClose}>Travel Management</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/online-research" onClick={handleClose}>Online Research</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/remote-executive-secretary" onClick={handleClose}>Remote Personal Assistant</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/sundry-tasks" onClick={handleClose}>Sundry Tasks</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/personal/ai-guidance" onClick={handleClose}>AI For Personal Life</a></li>
              </ul>
            </li>

            {/* Dropdown Menu */}
            <li className="nav-item dropdown show-in-mobile">
              <a className="nav-link dropdown-toggle" href="#" id="businessDropdown" role="button" data-bs-toggle="dropdown">
                For Business</a>
              <ul className="dropdown-menu" aria-labelledby="businessDropdown">
                <li className="nav-item"><a className="dropdown-item" href="/business/services" onClick={handleClose}>For Business</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/business-process-support" onClick={handleClose}>Business Process Support</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/research-analytics" onClick={handleClose}>Research & Analytics</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/remote-executive-secretary" onClick={handleClose}>Remote Executive Secretary</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/website-services" onClick={handleClose}>Website & App Development</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/digital-marketing" onClick={handleClose}>SEO/Digital Marketing</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/odoo-implementation" onClick={handleClose}>Odoo Implementation</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/bookkeeping-service" onClick={handleClose}>Bookkeeping Services</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/bookkeeping-service/quickbooks-bookkeeping" onClick={handleClose}>QuickBooks Bookkeeping</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/ai-automation" onClick={handleClose}>AI Automation & Integration</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/business/vacation-rental" onClick={handleClose}>Vacation Rental</a></li>
              </ul>
            </li>

            {/* Dropdown Menu */}
            <li className="nav-item dropdown show-in-mobile">
              <a className="nav-link dropdown-toggle" href="#" id="industriesDropdown" role="button" data-bs-toggle="dropdown">
                Industries</a>
              <ul className="dropdown-menu" aria-labelledby="industriesDropdown">
                <li className="nav-item"><a className="dropdown-item" href="/industries" onClick={handleClose}>All Industries</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/real-estate" onClick={handleClose}>Real Estate</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/ecommerce" onClick={handleClose}>Ecommerce</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/property-management" onClick={handleClose}>Property Management</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/legal-services" onClick={handleClose}>Legal Services</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/consulting" onClick={handleClose}>Consulting</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/small-business" onClick={handleClose}>Small Business</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/startups-entrepreneurs" onClick={handleClose}>Startups & Entrepreneurs</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/nonprofit-organizations" onClick={handleClose}>Nonprofit Organizations</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/vacation-rentals" onClick={handleClose}>Vacation Rentals</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/accounting-bookkeeping" onClick={handleClose}>Accounting & Bookkeeping</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/coaching-training" onClick={handleClose}>Coaching & Training</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/digital-marketing-agencies" onClick={handleClose}>Digital Marketing Agencies</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/education-edtech" onClick={handleClose}>Education & EdTech</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/financial-advisory" onClick={handleClose}>Financial Advisory</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/healthcare" onClick={handleClose}>Healthcare</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/hospitality" onClick={handleClose}>Hospitality</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/podcasting-content-creation" onClick={handleClose}>Podcasting & Content Creation</a></li>
                <li className="nav-item"><a className="dropdown-item" href="/industries/recruitment-staffing" onClick={handleClose}>Recruitment & Staffing</a></li>
              </ul>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/how-to-delegate" onClick={handleClose}>
                How to Delegate
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/personal/pricing-plans">
                Pricing
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/why-getfriday" onClick={handleClose}>
                Why GetFriday
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/faqs" onClick={handleClose}>
                FAQs
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/testimonials" onClick={handleClose}>
                Testimonial
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/contact-us" onClick={handleClose}>
                Contact us
              </a>
            </li>
            <li className="nav-item">
              <hr className="w-50 border-bottom-dashed"></hr>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/about-us" onClick={handleClose}>
                About Us
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/videos-and-podcasts">
                Podcast
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/press-and-media">
                Press & Announcements
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/refer-a-friend" onClick={handleClose}>
                Refer a friend
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/gift-of-time" onClick={handleClose}>
                Gift of time
              </a>
            </li>


            <li className="nav-item">
              <a className="nav-link" href="/how-we-work" onClick={handleClose}>
                How it works
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="https://www.getfriday.com/blog/" target="_blank" rel="noopener noreferrer">
                Blogs
              </a>
            </li>
            <li className="nav-item">
              <hr className="w-100 border-bottom-solid"></hr>
            </li>
          </ul>

          <div className='header-sidebar-contact mt-3 mb-3'>
            <h5>Call Us At</h5>
            <p className="phone" style={contactStyle}>UK :<a href="tel:+44-800-102-6200" style={{ textDecoration: "none", color: "#6c757d" }}> +44-800-102-6200 </a></p>
            <p className="phone" style={contactStyle}>US : <a href="tel:+1-877-879-4339" style={{ textDecoration: "none", color: "#6c757d" }}>+1-877-879-4339 </a></p>
            <p className="phone" style={contactStyle}>AUS : <a href="tel:+61-871-401-005" style={{ textDecoration: "none", color: "#6c757d" }}>+61-871-401-005 </a></p>
          </div>
          <p style={contactStyle} className="mb-3">We are available 24X7 for you</p>
          <div className='header-sidebar-contact mt-3 mb-3'>
            <h5>Get Social</h5>
            <FooterSocialIcons />
          </div>
        </Offcanvas.Body>

      </Offcanvas>
    </>
  );
}

export default RightSideMenu;